var _style, _metadata, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabricksId5WLjUbLd0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 276.4 42",
    style: {
      enableBackground: "new 0 0 276.4 42"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st0{fill:#FF3621;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#1B3139;}\n\t.st2{fill:#1B3139;}\n ")), _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", null, /*#__PURE__*/React.createElement("sfw", {
    xmlns: "ns_sfw;"
  }, /*#__PURE__*/React.createElement("slices", null), /*#__PURE__*/React.createElement("sliceSourceBounds", {
    bottomLeftOrigin: "true",
    height: 42,
    width: 276.4,
    x: -69.1,
    y: -10.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.1,31.1v-7.4l-0.8-0.5L20.1,33.7l-18.2-10l0-4.3l18.2,9.9l20.1-10.9v-7.3l-0.8-0.5L20.1,21.2L2.6,11.6 L20.1,2l14.1,7.7l1.1-0.6V8.3L20.1,0L0,10.9V12L20.1,23l18.2-10v4.4l-18.2,10L0.8,16.8L0,17.3v7.4l20.1,10.9l18.2-9.9v4.3l-18.2,10 L0.8,29.5L0,30v1.1L20.1,42L40.1,31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M78.3,2.2v33.7v0h-5.4v-2.5c0-0.2-0.1-0.4-0.3-0.4c-0.2-0.1-0.4,0-0.5,0.1c-1.9,2.1-4.7,3.4-7.8,3.4 c-3.2,0-6.2-1.3-8.4-3.5c-2.2-2.3-3.4-5.4-3.4-8.8c0-6.9,5.2-12.3,11.8-12.3c3.1,0,6,1.2,7.8,3.2c0.1,0.1,0.3,0.2,0.5,0.1 c0.2-0.1,0.3-0.2,0.3-0.4V2.2H78.3z M57.9,24.2c0,4.3,3.3,7.6,7.6,7.6c4.3,0,7.6-3.3,7.6-7.6c0-4.3-3.3-7.6-7.6-7.6 C61.3,16.6,57.9,19.9,57.9,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M106.9,12.4v23.5h-5.3v-2.5c0-0.2-0.1-0.4-0.3-0.4c-0.2-0.1-0.4,0-0.5,0.1c-1.9,2.2-4.7,3.4-7.8,3.4 c-6.6,0-11.8-5.4-11.8-12.3c0-6.9,5.2-12.3,11.8-12.3c3.2,0,6,1.1,7.8,3.2c0.1,0.1,0.3,0.2,0.5,0.1c0.2-0.1,0.3-0.2,0.3-0.4v-2.4 H106.9z M86.6,24.2c0,4.3,3.3,7.6,7.6,7.6c4.3,0,7.6-3.3,7.6-7.6c0-4.3-3.3-7.6-7.6-7.6C90,16.6,86.6,19.9,86.6,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.4,12.4v23.5h-5.3v-2.5c0-0.2-0.1-0.4-0.3-0.4c-0.2-0.1-0.4,0-0.5,0.1c-1.9,2.2-4.7,3.4-7.8,3.4 c-6.6,0-11.8-5.4-11.8-12.3c0-6.9,5.2-12.3,11.8-12.3c3.2,0,6,1.1,7.8,3.2c0.1,0.1,0.3,0.2,0.5,0.1c0.2-0.1,0.3-0.2,0.3-0.4v-2.4 H152.4z M132.1,24.2c0,4.3,3.3,7.6,7.6,7.6s7.6-3.3,7.6-7.6c0-4.3-3.3-7.6-7.6-7.6S132.1,19.9,132.1,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.4,33.1c-0.1,0-0.1,0-0.2,0c-0.2,0.1-0.3,0.2-0.3,0.4v2.4h-5.4l0-33.7h5.4l0,12.7c0,0.2,0.1,0.4,0.3,0.4 c0.2,0.1,0.4,0,0.5-0.1c1.9-2.1,4.7-3.4,7.8-3.4c3.2,0,6.2,1.3,8.4,3.5c2.2,2.3,3.4,5.4,3.4,8.8c0,6.9-5.2,12.3-11.8,12.3 c-3.1,0-6-1.2-7.8-3.2C162.6,33.2,162.5,33.1,162.4,33.1z M169.3,16.6c-4.3,0-7.6,3.3-7.6,7.6c0,4.3,3.3,7.6,7.6,7.6 c4.3,0,7.6-3.3,7.6-7.6C176.9,19.9,173.5,16.6,169.3,16.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M197.8,17.2c0.5,0,1,0,1.3,0.1V12c-0.2,0-0.5-0.1-0.9-0.1c-2.8,0-5.4,1.4-6.7,3.6c-0.1,0.2-0.3,0.3-0.5,0.2 c-0.2-0.1-0.3-0.2-0.3-0.4v-2.9h-5.3v23.5h5.4V25.6C190.6,20.4,193.4,17.2,197.8,17.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.4,
    y: 12.4,
    className: "st2",
    width: 5.4,
    height: 23.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M205.1,2.2c-1.8,0-3.3,1.4-3.3,3.2s1.5,3.2,3.3,3.2c1.8,0,3.3-1.4,3.3-3.2C208.4,3.7,206.9,2.2,205.1,2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M223.8,11.9c-7.4,0-12.8,5.2-12.8,12.3c0,3.5,1.3,6.6,3.6,8.8c2.3,2.2,5.6,3.5,9.2,3.5c3,0,5.4-0.6,9.8-3.7 l-3-3.1c-2.2,1.4-4.2,2.1-6.2,2.1c-4.5,0-7.9-3.3-7.9-7.6c0-4.3,3.4-7.6,7.9-7.6c2.1,0,4.1,0.7,6.1,2.1l3.4-3.1 C229.8,12.2,226.2,11.9,223.8,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M242.9,25.6c0.1-0.1,0.2-0.1,0.3-0.1h0c0.1,0,0.2,0.1,0.3,0.2l8.6,10.3l6.6,0l-11.1-13c-0.2-0.2-0.1-0.4,0-0.6 l10.2-9.9h-6.5l-8.8,8.5c-0.1,0.1-0.3,0.2-0.5,0.1c-0.2-0.1-0.3-0.2-0.3-0.4l0-18.5h-5.4v33.7h5.4v-9.1c0-0.1,0.1-0.2,0.1-0.3 L242.9,25.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M267.6,36.5c4.4,0,8.9-2.6,8.9-7.5c0-3.2-2.1-5.4-6.4-6.8l-2.9-0.9c-2-0.6-2.9-1.5-2.9-2.8 c0-1.4,1.3-2.4,3.2-2.4c1.8,0,3.4,1.1,4.4,3.1l4.3-2.2c-1.6-3.2-4.9-5.1-8.7-5.1c-4.8,0-8.3,3-8.3,7.1c0,3.3,2,5.5,6.1,6.7l3,0.9 c2.1,0.6,3,1.4,3,2.8c0,2-1.9,2.7-3.5,2.7c-2.2,0-4.1-1.4-5.1-3.6l-4.4,2.2C259.7,34.3,263.3,36.5,267.6,36.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M121.8,36.3c1.7,0,3.2-0.1,4.1-0.3v-4.5c-0.7,0.1-1.9,0.2-2.7,0.2c-2.2,0-3.8-0.4-3.8-4.9v-9.6 c0-0.2,0.2-0.4,0.5-0.4h5.2l0-4.2l-5.2,0c-0.3,0-0.5-0.2-0.5-0.4V5.2l-5.3,0l0,6.8c0,0.2-0.2,0.4-0.5,0.4h-3.7l0,4.2l3.7,0 c0.3,0,0.5,0.2,0.5,0.4v10.9C114,36.3,119.7,36.3,121.8,36.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabricksId5WLjUbLd0);
export default __webpack_public_path__ + "static/media/Databricks_id5WLjUbLd_0.0237d6d017e3e0a1d98196c32a06c63d.svg";
export { ForwardRef as ReactComponent };